import patientsAPI from './patientsAPI';

export default {
  single: patientsAPI,
};
